import {DqButtonPosition} from 'module/DqButton/type/DqButtonLocations'
import {DqButtonStateType} from 'module/DqButton/reducer/DqButtonReducer'

export function findDqButtonsAt(dqButtonByLocationType: DqButtonStateType['DqButton']['byLocation'], positions: DqButtonPosition[]) {
	return positions.flatMap(p => dqButtonByLocationType[p.location]?.filter(x =>
		!x.locationDiscriminator && !p.locationDiscriminator ||
		x.locationDiscriminator === p.locationDiscriminator,
	) || []).sort((a, b) => a.position - b.position)
}